(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["age-popup"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('age-popup')) {
		const DialogElement = customElements.get('dialog-element')
		const AGE_POPUP_EASING = 'cubic-bezier(0.645, 0.045, 0.355, 1)'
		const AGE_POPUP_DURATION = 400

		const createAgePopupAnimationControls = (animations) => ({
			finished: Promise.all(animations.map((animation) => animation.finished)),
			finish: () => animations.forEach((animation) => animation.finish()),
		})

		class AgePopup extends DialogElement {
			connectedCallback() {
				super.connectedCallback()
				this.storageKey = 'theme:age-verified'

				this.addEventListener(
					'click',
					(event) => {
						const trigger = event.target.closest('[data-action]')
						if (!trigger) return

						if (trigger.dataset.action === 'accept') {
							localStorage.setItem(this.storageKey, 'true')
							this.hide()
						}

						if (trigger.dataset.action === 'decline') {
							const url = this.getAttribute('decline-url')
							if (url) window.location.href = url
						}
					},
					{ signal: this.abortController.signal }
				)

				this.addEventListener(
					'dialog:after-hide',
					() => {
						this.classList.remove('age-popup--closing')
					},
					{ signal: this.abortController.signal }
				)

				if (!Shopify.designMode && localStorage.getItem(this.storageKey) !== 'true') {
					this.show(false)
				}
			}

			hide() {
				this.classList.add('age-popup--closing')
				this.style.setProperty('display', 'flex')
				return super.hide()
			}

			get shouldLock() {
				return true
			}

			get shouldAppendToBody() {
				return true
			}

			get clickOutsideDeactivates() {
				return false
			}

			createEnterAnimationControls() {
				if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
					return { finished: Promise.resolve(), finish() {} }
				}

				const dialog = this.querySelector('.age-popup__dialog')
				const options = { duration: AGE_POPUP_DURATION, easing: AGE_POPUP_EASING }

				return createAgePopupAnimationControls(
					[
						this.animate({ opacity: [0, 1] }, options),
						dialog?.animate({ transform: ['translateY(16px)', 'translateY(0)'] }, options),
					].filter(Boolean)
				)
			}

			createLeaveAnimationControls() {
				if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
					return { finished: Promise.resolve(), finish() {} }
				}

				const dialog = this.querySelector('.age-popup__dialog')
				const options = { duration: AGE_POPUP_DURATION, easing: AGE_POPUP_EASING, fill: 'forwards' }

				return createAgePopupAnimationControls(
					[
						this.animate({ opacity: [1, 0] }, options),
						dialog?.animate({ transform: ['translateY(0)', 'translateY(16px)'] }, options),
					].filter(Boolean)
				)
			}
		}

		customElements.define('age-popup', AgePopup)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	if (!customElements.get('l-footer-sticky')) {
		class LTAFooterSticky extends HTMLElement {
			constructor() {
				super()
				this._sectionEl = null
				this._containerEl = null
				this._rafId = null
				this._resizeObserver = null
				this._cleanups = []
				this._reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
				this._onScroll = this._onScroll.bind(this)
			}

			connectedCallback() {
				this._sectionEl = this.closest('footer')
				this._containerEl = this.querySelector('[data-footer-container]')

				if (!this._sectionEl || !this._containerEl) return

				window.addEventListener('scroll', this._onScroll, { passive: true })
				window.addEventListener('resize', this._onScroll)
				this._cleanups.push(() => window.removeEventListener('scroll', this._onScroll))
				this._cleanups.push(() => window.removeEventListener('resize', this._onScroll))

				this._resizeObserver = new ResizeObserver(this._onScroll)
				this._resizeObserver.observe(this._sectionEl)
				this._resizeObserver.observe(this._containerEl)
				this._cleanups.push(() => this._resizeObserver.disconnect())

				if (window.Shopify?.designMode) {
					document.addEventListener('shopify:section:load', this._onScroll)
					document.addEventListener('shopify:section:reorder', this._onScroll)
					this._cleanups.push(() => document.removeEventListener('shopify:section:load', this._onScroll))
					this._cleanups.push(() => document.removeEventListener('shopify:section:reorder', this._onScroll))
				}

				this._updatePosition()
			}

			disconnectedCallback() {
				if (this._rafId) {
					cancelAnimationFrame(this._rafId)
					this._rafId = null
				}

				this._cleanups.forEach((cleanup) => cleanup())
				this._cleanups = []
				this._containerEl?.style.removeProperty('transform')
			}

			_onScroll() {
				if (this._rafId) return

				this._rafId = requestAnimationFrame(() => {
					this._rafId = null
					this._updatePosition()
				})
			}

			_getTopOffset() {
				const value = getComputedStyle(this._sectionEl).getPropertyValue('--footer-sticky-top-offset').trim()
				const parsed = parseFloat(value)

				return Number.isFinite(parsed) ? parsed : 90
			}

			_updatePosition() {
				if (!this._sectionEl || !this._containerEl || this._reducedMotion.matches) {
					this._containerEl?.style.removeProperty('transform')
					return
				}

				const topOffset = this._getTopOffset()
				const travel = Math.max(0, this.offsetHeight - this._containerEl.offsetHeight - topOffset)

				if (travel === 0) {
					this._containerEl.style.removeProperty('transform')
					return
				}

				const stickyRect = this.getBoundingClientRect()
				const offset = Math.min(0, Math.max(-travel, window.innerHeight - stickyRect.bottom))

				if (offset === 0) {
					this._containerEl.style.removeProperty('transform')
					return
				}

				this._containerEl.style.transform = `translate3d(0, ${offset}px, 0)`
			}
		}

		customElements.define('l-footer-sticky', LTAFooterSticky)
	}

  } catch(e) { console.error(e); }
})();
})();
